import { Dispatch } from 'redux';
import { ITimeUsageReport } from '../../../models/TimeUsageReport.model';
import * as Actions from './reportsActions';
import { ReportsConstants } from './reportsConstants';
import ReportsService from '../../../components/reports/ReportsService';
import { ISideFilter } from '../../../models/SideFilterObject.model';

export function setSelectedTab(payload: number): Actions.SetActiveTab {
  return {
    type: ReportsConstants.SET_ACTIVE_TAB,
    payload,
  };
}

export function createTimeUsageReportsRequest(): Actions.GetTimeUsageReports {
  return {
    type: ReportsConstants.GET_TIME_USAGE_REPORTS_REQUEST,
  };
}
export function createTimeUsageReportsSuccess(
  payload: Array<ITimeUsageReport>,
): Actions.GetTimeUsageReports.Success {
  return {
    type: ReportsConstants.GET_TIME_USAGE_REPORTS_SUCCESS,
    payload,
  };
}
export function createTimeUsageReportsFailure(
  error: Error,
): Actions.GetTimeUsageReports.Failure {
  return {
    type: ReportsConstants.GET_TIME_USAGE_REPORTS_FAILURE,
    error,
  };
}

export function loadTimeUsageReports(
  from: Date | string,
  to: Date | string,
  ignoreCache: boolean = false,
): (dispatch: Dispatch<Actions.All>) => Promise<void> {
  return async function (dispatch: Dispatch<Actions.All>): Promise<void> {
    dispatch(createTimeUsageReportsRequest());
    try {
      const result: Array<ITimeUsageReport> =
        await ReportsService.getTimeUsageReports(from, to, ignoreCache);
      dispatch(createTimeUsageReportsSuccess(result));
    } catch (error) {
      dispatch(createTimeUsageReportsFailure(error));
    }
  };
}

export function setFilterValues(payload: ISideFilter): Actions.SetFilterValues {
  return {
    type: ReportsConstants.SET_FILTER_VALUES,
    payload,
  };
}

export function setChartVisibility(
  payload: boolean,
): Actions.SetChartVisibility {
  return {
    type: ReportsConstants.SET_CHARTS_VISIBILITY,
    payload,
  };
}
